import Loading from "./Loading.vue";
import LoadingSpan from "./LoadingSpan.vue";
import LoadingPage from "./LoadingPage.vue";
import Button from "./Button.vue";
import NoData from "./NoData.vue";
import Modal from "./Modal.vue";
import Input from "./input";

import Table from "./Table.vue";

export default [Loading, LoadingSpan, LoadingPage, Button, NoData, Modal, Table, ...Input];
